
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const ConversionRate: React.FC = () => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">
          Taxa de Conversão
        </CardTitle>
        <CardDescription>Conversão de visitantes para usuários pagantes</CardDescription>
      </CardHeader>
      <CardContent className="pt-0 h-full flex flex-col justify-center">
        <div className="relative mx-auto w-40 h-40 flex items-center justify-center">
          <svg className="w-full h-full" viewBox="0 0 100 100">
            {/* Background circle */}
            <circle 
              cx="50" 
              cy="50" 
              r="40" 
              fill="none" 
              stroke="#e5e7eb" 
              strokeWidth="10"
            />
            {/* Progress circle */}
            <circle 
              cx="50" 
              cy="50" 
              r="40" 
              fill="none" 
              stroke="#8b5cf6" 
              strokeWidth="10"
              strokeDasharray="251.2"
              strokeDashoffset="100.48" // 251.2 * (1 - 0.6) progress is 60%
              transform="rotate(-90 50 50)"
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-3xl font-bold">60%</span>
            <span className="text-xs text-muted-foreground">Conversão</span>
          </div>
        </div>
        <p className="text-center text-sm text-muted-foreground mt-4">
          60% dos visitantes registrados se tornam usuários pagantes
        </p>
      </CardContent>
    </Card>
  );
};

export default ConversionRate;
